<template>
  <form
    name="publications-form"
    class="PublicationForm"
    @submit.prevent="$emit('save')"
  >
    <BLayoutExpansion class="my-4">
      <v-row class="d-flex justify-space-between mb-6 bg-surface-variant">
        <v-col cols="6" fluid>
          <v-row v-if="isCreate" dense>
            <v-col :key="data.name">
              <BAutocompleteCommon
                v-model="data.name"
                $type="event-publications"
                @change="onPublicationSelected($event)"
              />
            </v-col>
          </v-row>

          <v-row v-if="isCreate" dense>
            <v-col :key="data.lk_storage_name">
              <BAutocompleteCommon
                v-model="data.lk_storage_name"
                $type="event-publications-storages"
                :publication="data.lk_publication_id"
                :disabled="data.lk_publication_id === null"
                :exclude="criteriaStorageExclude"
                name="lk_storage_name"
                validate="required"
                :label="kimsStorageLabel"
                @change="onPublicationStorageSelected($event)"
              />
            </v-col>
          </v-row>

          <v-row v-if="isCreate" dense>
            <v-col :key="data.lk_criteria_storage_name">
              <BAutocompleteCommon
                v-model="data.lk_criteria_storage_name"
                $type="event-publications-storages"
                :publication="data.lk_publication_id"
                :disabled="!data.lk_publication_id"
                :exclude="kimsStorageExclude"
                name="lk_criteria_storage_name"
                :label="criteriaStorageLabel"
                @change="onCriteriaStorageSelected($event)"
              />
            </v-col>
          </v-row>

          <!-- Информационный блок с уменьшенными шрифтами -->
          <v-row v-if="!isCreate" dense class="mb-3">
            <v-col>
              <v-card flat>
                <div class="PublicationForm__info-list">
                  <v-row dense class="PublicationForm__info-row">
                    <v-col cols="12" sm="5" class="PublicationForm__info-label">
                      Оценочная процедура:
                    </v-col>
                    <v-col cols="12" sm="7" class="PublicationForm__info-value">
                      {{ data.procedure_name }}
                    </v-col>
                  </v-row>
                  <v-row dense class="PublicationForm__info-row">
                    <v-col cols="12" sm="5" class="PublicationForm__info-label">
                      Сессия:
                    </v-col>
                    <v-col cols="12" sm="7" class="PublicationForm__info-value">
                      {{ data.session_name }}
                    </v-col>
                  </v-row>
                  <v-row dense class="PublicationForm__info-row">
                    <v-col cols="12" sm="5" class="PublicationForm__info-label">
                      Предмет:
                    </v-col>
                    <v-col cols="12" sm="7" class="PublicationForm__info-value">
                      {{ data.subject_name }}
                    </v-col>
                  </v-row>
                  <v-row dense class="PublicationForm__info-row">
                    <v-col cols="12" sm="5" class="PublicationForm__info-label">
                      Мероприятие:
                    </v-col>
                    <v-col cols="12" sm="7" class="PublicationForm__info-value">
                      {{ data.event_name }}
                    </v-col>
                  </v-row>
                  <v-row dense class="PublicationForm__info-row">
                    <v-col cols="12" sm="5" class="PublicationForm__info-label">
                      {{ kimsStorageLabel }}:
                    </v-col>
                    <v-col cols="12" sm="7" class="PublicationForm__info-value">
                      {{ formatStorage(data.lk_storage_name, data.lk_storage_id) }}
                    </v-col>
                  </v-row>
                  <v-row dense class="PublicationForm__info-row">
                    <v-col cols="12" sm="5" class="PublicationForm__info-label">
                      {{ criteriaStorageLabel }}:
                    </v-col>
                    <v-col cols="12" sm="7" class="PublicationForm__info-value">
                      {{ formatStorage(data.lk_criteria_storage_name, data.lk_criteria_storage_id) }}
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="!isCreate" dense>
            <v-col>
              <BFileUpload
                accept=".zip"
                label="Загрузка вариантов"
                @change="variantsFile = $event"
              />
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                :disabled="!variantsFile"
                @click="onUploadFile(variantsFile, 'KIMS_VARIANTS')"
                v-text="'Загрузить'"
              />
            </v-col>
          </v-row>
          <v-row v-if="!isCreate && hasCriteriaStorage" dense>
            <v-col>
              <BFileUpload
                accept=".zip"
                label="Загрузка критериев"
                :disabled="!canUploadCriteria"
                @change="criteriaFile = $event"
              />
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                :disabled="!canUploadCriteria || !criteriaFile"
                @click="onUploadFile(criteriaFile, 'KIMS_CRITERIA')"
                v-text="'Загрузить'"
              />
            </v-col>
          </v-row>
          <v-row v-if="!isCreate" dense>
            <v-col>
              <BFileUpload
                accept=".xlsx"
                label="Загрузка описи"
                :disabled="!canUploadUsers"
                @change="usersFile = $event"
              />
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                :disabled="!canUploadUsers || !usersFile"
                @click="onUploadFile(usersFile, 'KIMS')"
                v-text="'Загрузить'"
              />
            </v-col>
          </v-row>
          <v-row v-if="!isCreate" dense>
            <v-col>
              <BFileUpload
                accept=".csv"
                label="Загрузка монтажного листа"
                :disabled="!canUploadGuideTasks"
                @change="listFile = $event"
              />
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                :disabled="!canUploadGuideTasks || !listFile"
                @click="onUploadFile(listFile, 'KIMS_GUID_TASKS')"
                v-text="'Загрузить'"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="auto">
              <v-skeleton-loader :loading="skeleton" type="sentences">
                <v-checkbox
                  v-model="data.is_show"
                  label="Отображать для сбора отсканированных комплектов"
                  dense
                  hide-details
                  class="ma-0 pa-0"
                  name="reverse_ordering"
                />
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row v-if="!isCreate" dense>
            <v-col :cols="!skeleton && 'auto'">
              <BTextField
                :value="data.created_at | dateFormatter"
                :skeleton="skeleton"
                label="Создан"
                disabled
              />
            </v-col>

            <v-col :cols="!skeleton && 'auto'">
              <BTextField
                :value="data.updated_at | dateFormatter"
                :skeleton="skeleton"
                label="Обновлен"
                disabled
              />
            </v-col>
          </v-row>
          <v-row v-if="!isCreate" dense>
            <ViewCollectorPublicationsView />
          </v-row>
          <v-col v-if="tasksInfo">
            <v-row v-for="(object, index) in tasksInfo" :key="index">
              <span v-if="object.exc_info !== null" class="red--text">
                {{ object.exc_info }}
              </span>
            </v-row>
          </v-col>
        </v-col>
        <v-col v-if="!isCreate" cols="5">
          <v-row>
            <v-col>
              Сформировано комплектов
            </v-col>
            <v-col>
              {{ data.generated_complects_count || 0 }} /
              {{ data.target_complects_count || 0 }}
            </v-col>
          </v-row>

          <v-progress-linear
            class="LKMunMehCardProgress__progress"
            :value="
              ((data.generated_complects_count || 0) /
                (data.target_complects_count || 1)) *
                100
            "
            height="12"
          />
          <template v-if="hasCriteriaStorage">
            <v-row class="mt-2">
              <v-col>
                Сформировано критериев
              </v-col>
              <v-col>
                {{ data.generated_criteria_count || 0 }} /
                {{ data.target_criteria_count || 0 }}
              </v-col>
            </v-row>

            <v-progress-linear
              class="LKMunMehCardProgress__progress"
              :value="
                ((data.generated_criteria_count || 0) /
                  (data.target_criteria_count || 1)) *
                  100
              "
              height="12"
            />
          </template>
          <v-row class="mt-2" dense>
            <v-col cols="auto">
              <v-btn
                depressed
                block
                :disabled="!generateKims"
                @click="onGenerateKims"
                v-text="'Сгенерировать КИМы'"
              />
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col>
              Экспортировано в ЛК КИМов
            </v-col>
            <v-col>
              {{ reportTask ? reportTask.imported : 0 }} /
              {{ data.participants_count || 0 }}
            </v-col>
          </v-row>

          <v-progress-linear
            class="LKMunMehCardProgress__progress"
            :value="
              ((reportTask ? reportTask.imported : 0) /
                (data.participants_count || 1)) *
                100
            "
            height="12"
          />
          <v-row v-if="reportTask" class="mt-2">
            <v-col>
              {{ informationAboutTask }}
            </v-col>
          </v-row>
          <v-row v-if="reportTask && reportTask.exc_info" class="mt-2">
            <v-col class="error--text">
              {{ reportTask.exc_info }}
            </v-col>
          </v-row>
          <v-row class="mt-2" dense>
            <v-col cols="auto">
              <v-btn
                depressed
                block
                :disabled="!importKims"
                @click="onImportKims"
                v-text="'Отправить КИМы в ЛК'"
              />
            </v-col>
          </v-row>

          <template v-if="hasCriteriaStorage">
            <v-row class="mt-2">
              <v-col>
                Экспортировано в ЛК Критериев
              </v-col>
              <v-col>
                {{ criteriaReportTask ? criteriaReportTask.imported : 0 }} /
                {{ data.participants_count_with_criteria || 0 }}
              </v-col>
            </v-row>

            <v-progress-linear
              class="LKMunMehCardProgress__progress"
              :value="
                ((criteriaReportTask ? criteriaReportTask.imported : 0) /
                  (data.participants_count_with_criteria || 1)) *
                  100
              "
              height="12"
            />
            <v-row v-if="criteriaReportTask" class="mt-2">
              <v-col>
                {{ criteriaInformationAboutTask }}
              </v-col>
            </v-row>
            <v-row v-if="criteriaReportTask && criteriaReportTask.exc_info" class="mt-2">
              <v-col class="error--text">
                {{ criteriaReportTask.exc_info }}
              </v-col>
            </v-row>
            <v-row class="mt-2" dense>
              <v-col cols="auto">
                <v-btn
                  depressed
                  block
                  :disabled="!importCriteria"
                  @click="onImportCriteria"
                  v-text="'Отправить критерии в ЛК'"
                />
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>
      <slot name="save-menu" />
    </BLayoutExpansion>
    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'
import BFileUpload from '@/components/forms/BFileUpload.vue'
import ViewCollectorPublicationsView from '@/views/CollectorPublications/PublicationsView.vue'

import { Adapter } from '@/store/createCrudModule'
import { CollectorPublicationsApi } from '@/api/resources/Collector/CollectorPublicationsApi'
import { CollectorTaskStatus } from '@/typings/api/CollectorPublication'
import { CollectorKimsTasksApi } from '@/api/resources/Collector/CollectorKimsTasksApi'
import { ImportKimsTasksApi } from '@/api/resources/Collector/CollectorKimsTasksImportApi'
import { CollectorTasksInfo } from '@/api/resources/Collector/CollectorTasksInfo'
import { KimCriteriaApi, KimUsersApi, KimVariantApi } from '@/api/resources'

const createDefaultData = () => ({
  name: null,
  lk_publication_id: null,
  start_at: void 0,
  end_at: void 0,
  procedure_digital_code: void 0,
  published_at: void 0,
  lk_storage_id: void 0,
  lk_criteria_storage_id: null,
  lk_criteria_storage_name: null,
  lk_storage_name: null,
  is_show: true,
})

export default {
  name: 'BasePublicationsForm',
  components: {
    BLayoutExpansion,
    BTextField,
    BAutocompleteCommon,
    BFileUpload,
    ViewCollectorPublicationsView,
  },
  extends: BLayoutForm,
  props: {
    editable: Boolean,
    skeleton: Boolean,
    loading: Boolean,
    selectedPublication: Object,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
    currentPublication: {
      type: Object,
      default: createDefaultData,
    },
  },
  data() {
    return {
      variantsFile: null,
      usersFile: null,
      criteriaFile: null,
      listFile: null,
      isLoading: true,
      reportTask: null,
      criteriaReportTask: null,
      tasksInfo: null,
      criteriaTask: null,
      uploadAvailability: {
        variants: false,
        criteria: false,
        users: false,
      },
    }
  },
  computed: {
    kimsStorageLabel() {
      return 'Хранилище КИМов'
    },
    criteriaStorageLabel() {
      return 'Хранилище критериев (необязательно)'
    },
    kimsStorageExclude() {
      return Number.isFinite(this.data.lk_storage_id)
        ? [{ id: this.data.lk_storage_id }]
        : []
    },
    criteriaStorageExclude() {
      return Number.isFinite(this.data.lk_criteria_storage_id)
        ? [{ id: this.data.lk_criteria_storage_id }]
        : []
    },
    hasCriteriaStorage() {
      return Boolean(this.data.lk_criteria_storage_id)
    },
    hasVariants() {
      return this.uploadAvailability.variants
    },
    canUploadCriteria() {
      return this.hasVariants
    },
    hasUploadedCriteria() {
      if (!this.hasCriteriaStorage) return true

      return this.uploadAvailability.criteria
    },
    canUploadUsers() {
      return this.hasVariants
    },
    canUploadGuideTasks() {
      return this.hasVariants && this.uploadAvailability.users
    },
    criteriaInformationAboutTask() {
      switch (this.criteriaReportTask.status) {
        case CollectorTaskStatus.pending:
        case CollectorTaskStatus.in_progress:
          return 'Критерии переносятся'
        case CollectorTaskStatus.done:
          return 'Критерии перенесены'
        case CollectorTaskStatus.error:
          return 'Не удалось перенести критерии'
        default:
          return this.criteriaReportTask.status
      }
    },
    informationAboutTask() {
      switch (this.reportTask.status) {
        case CollectorTaskStatus.pending:
          return 'Варианты переносятся'
        case CollectorTaskStatus.in_progress:
          return 'Варианты переносятся'
        case CollectorTaskStatus.done:
          return 'Варианты перенесены'
        case CollectorTaskStatus.error:
          return 'Не удалось перенести варианты'
        default:
          return this.reportTask.status
      }
    },
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        if (this.data.publication_id) {
          this.getTasksInfo()
          this.getUploadAvailability()

          if (this.data.target_complects_count) {
            this.getImportKimsTasks(this.data.lk_storage_id)
            if (this.hasCriteriaStorage) this.getImportKimsTasks(this.data.lk_criteria_storage_id, true)
          }
        }
      },
    },
  },
  methods: {
    formatStorage(name, id) {
      const storageName = name || '-'
      return Number.isFinite(id) ? `${storageName} (${id})` : storageName
    },
    onPublicationSelected(topic) {
      if (topic === null) {
        this.data.lk_publication_id = null
        this.data.lk_storage_id = null
        this.data.lk_storage_name = null
        this.data.lk_criteria_storage_id = null
        this.data.lk_criteria_storage_name = null
      } else {
        this.data.lk_publication_id = topic.id
        this.data.name = topic.name
        this.data.end_at = topic.end_at
        this.data.start_at = topic.start_at
        this.data.procedure_digit_code = topic.procedure.digit_code
        this.data.published_at = topic.published_at
      }
    },
    onPublicationStorageSelected(topic) {
      if (topic && topic.id === this.data.lk_criteria_storage_id) {
        this.data.lk_storage_id = null
        this.data.lk_storage_name = null
        return
      }

      this.data.lk_storage_id = topic ? topic.id : null
      this.data.lk_storage_name = topic ? topic.name : null
    },
    onCriteriaStorageSelected(topic) {
      if (topic && topic.id === this.data.lk_storage_id) {
        this.data.lk_criteria_storage_id = null
        this.data.lk_criteria_storage_name = null
        return
      }

      this.data.lk_criteria_storage_id = topic ? topic.id : null
      this.data.lk_criteria_storage_name = topic ? topic.name : null
    },
    async onSave() {
      const isValid = await this.$validator.validate()
      if (!isValid) {
        this.$notice.validatorFormError(this)
        return
      }

      const api = new CollectorPublicationsApi()
      const adapter = new Adapter(api)
      try {
        const params = {
          lk_publication_id: this.data.lk_publication_id,
          name: this.data.name,
          end_at: this.data.end_at,
          start_at: this.data.start_at,
          procedure_digital_code: this.data.procedure_digit_code,
          published_at: this.data.published_at,
          lk_storage_id: this.data.lk_storage_id,
          lk_storage_name: this.data.lk_storage_name,
          is_show: this.data.is_show,
          lk_criteria_storage_id: this.data.lk_criteria_storage_id,
          lk_criteria_storage_name: this.data.lk_criteria_storage_name,
        }

        if (!this.isCreate) {
          await adapter.update(this.form.publication_id, params)
        } else {
          const { data } = await adapter.create(params)
          this.$emit('created:publication', data)
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoadingData = false
      }
    },
    async updatePublication() {
      const api = new CollectorPublicationsApi()
      const adapter = new Adapter(api)
      const { data } = await adapter.getOne(this.data.publication_id)
      this.$emit('updated:publication', data)
      await this.getTasksInfo()

      return data
    },
    async getTasksInfo() {
      const api = new CollectorTasksInfo()
      const { data } = await api.getTasksInfo(this.data.publication_id)

      const uniqueObjects = []
      const typeCount = {}

      data.forEach((obj) => {
        if (!typeCount[obj.type] && uniqueObjects.length < 4) {
          typeCount[obj.type] = true
          uniqueObjects.unshift(obj)
        }
      })
      this.tasksInfo = uniqueObjects
      this.criteriaTask = data.find(({ type, status }) => (
        type === 'KIMS_CRITERIA'
        && ![CollectorTaskStatus.error, 'ERROR'].includes(status)
      )) || null

      return this.criteriaTask
    },
    async getUploadAvailability() {
      const publicationId = this.data.publication_id
      const params = { publication_id: publicationId, page: 1, per_page: 1 }
      try {
        const [variants, criteria, users] = await Promise.all([
          new KimVariantApi().getAll(params),
          this.hasCriteriaStorage
            ? new KimCriteriaApi().getAll(params)
            : Promise.resolve({ meta: { count: 0 } }),
          new KimUsersApi().getAll(params),
        ])

        if (this.data.publication_id !== publicationId) return

        this.uploadAvailability = {
          variants: Boolean(variants.meta.count),
          criteria: Boolean(criteria.meta.count),
          users: Boolean(users.meta.count),
        }
      } catch (e) {
        this.$notice.errors(e)
      }
    },
    async onGenerateKims() {
      try {
        const api = new CollectorKimsTasksApi()
        const { data } = await api.generateKims(this.data.publication_id)
        const {
          users_started: usersStarted = 0,
          users_errors: usersErrors = 0,
          errors_with: errorsWith = [],
        } = data
        const messages = usersStarted
          ? [`КИМы генерируются. Запущено пользователей: ${usersStarted}.`]
          : ['Не найдено пользователей, для которых можно запустить генерацию КИМов.']

        if (usersErrors) messages.push(`Ошибок: ${usersErrors}.`)
        if (errorsWith.length) messages.push(`Детали ошибок: ${JSON.stringify(errorsWith)}`)

        this.$notice.info(messages.join(' '))
        return data
      } catch (e) {
        this.$notice.errors(e)
        return Promise.reject(e)
      }
    },
    async getImportKimsTasks(storageId, isCriteria = false) {
      try {
        const api = new ImportKimsTasksApi()
        const {
          data: [firstItem],
        } = await api.getImportedKimsByStorage(storageId)
        if (isCriteria) this.criteriaReportTask = firstItem
        else this.reportTask = firstItem
        return firstItem
      } catch (e) {
        this.$notice.errors(e)
        return Promise.reject(e)
      }
    },
    onInputStart(date) {
      this.data.start_at = date
    },
    onInputEnd(date) {
      this.data.end_at = date
    },
  },
}
</script>

<style lang="scss" scoped>
.PublicationForm {

  &__info-list {
    padding: 16px;
  }

  &__info-row + &__info-row {
    margin-top: 8px;
  }

  &__info-label {
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);
  }

  &__info-value {
    min-width: 0;
    font-size: 14px;
    word-break: break-word;
  }

  &__link {
    display: block;
    margin: 0 4px;
    color: $webflow-color-black;
    cursor: pointer;
    text-decoration-line: none;

    &:hover {
      opacity: 0.75;
    }
  }

  &__link-icon {
    pointer-events: none;
  }

  .LKMunMehCardProgress {
    margin-top: 16px;

    &__text {
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: bold;
      color: $webflow-color-blue-dark-2;
    }

    &__progress {
      border-radius: 4px;
    }

    .v-progress-linear {
      &__buffer {
        background-color: $webflow-color-grey;
      }

      .primary {
        background-color: $webflow-color-green;
      }
    }
  }
}
</style>
